<!-- <div class="container col-sm-8 pt-5 webview text-center">
    <h1 class="text-center font-weight-normal-calibre pb-4">{{question}}</h1>
    <div class="form-group col-sm-5 m-auto">
        <input type="text" class="form-control" [(ngModel)]="energy_bill_number" placeholder="Energy Bill Number" />
    </div>
    <button class="btn mr-2 ml-2 sectbtn col-md-5 col-lg-4 mt-4 font18 text-uppercase" (click)="next();">Next</button>
    <p class="text-success mt-3" *ngIf="showTip">{{questionObj.tip}}</p>
</div> -->
<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
    <div class="col-sm-12">
        <div class="d-flex  m-auto col-sm-6 col-md-6 col-xl-8">
            <div class="col-6 q-cards">
                <label class="card card-list w-100 pt-2 text-center d-inline-block pull-right" for="Yes">
                    <img src="{{yes_src}}" height="100px">
                    <div></div>
                    <label for="Yes">Yes</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="Yes" value="Yes" name="yes_no"
                            [(ngModel)]="hgValue.value1" (click)="getValue($event)" />
                        <label class="custom-control-label" for="Yes"></label>
                    </div>
                </label>
            </div>
            <div class="col-6 q-cards">
                <label class="card card-list w-100 pt-2 text-center d-inline-block pull-left" for="No">
                    <img src="{{no_src}}" height="100px">
                    <div></div>
                    <label for="No">No</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="No" value="No" name="yes_no"
                            [(ngModel)]="hgValue.value2" (click)="getValue($event)" />
                        <label class="custom-control-label" for="No"></label>
                    </div>
                </label>
            </div>
        </div>
    </div>
    <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <!-- <p class="text-success mt-3">{{questionObj.tip}}</p> -->
    <button class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}"(click)="next();">Next</button>
    <div class="mt-5">
        <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
            <img src="assets/images/flash.png" class="mb-1" />
            <p class="text-center tiphead">SUGGESTION</p>
            <p class="text-center tipmes">{{questionObj.tip}}</p>
            <!-- <p class="text-center font-weight-bold">SUGGESTION<br>
                <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
    </div>
</div>
<div class="container mobileview mt-2 px-0" [attr.id]="questionObj._id">
    <div class="d-flex h-100 row col-sm-12 pr-0">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box" >
                <h1 class="questionMob text-left">{{question}}</h1>
            </div>
        </div>
    </div>
    <div class="row m-auto">
        <div class="col-12 d-flex">
            <div class="col-6 box-shadow-none pl-0">
                <label class="card card-list text-center d-inline-block" for="Yes" style="width:100%; min-height: 156px;">
                    <img src="{{yes_src}}" width="60%">
                    <br>
                    <label for="Yes">Yes</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="Yes_mob" value="Yes" name="yes_no"
                            [(ngModel)]="hgValue.value1" (click)="getValue($event)" />
                        <label class="custom-control-label" for="Yes"></label>
                    </div>
                </label>
            </div>
            <div class="col-6 box-shadow-none pr-0">
                <label class="card card-list text-center d-inline-block" for="No" style="width:100%; min-height: 156px;">
                    <img src="{{no_src}}" width="60%">
                    <br>
                    <label for="No">No</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="No_mob" value="No" name="yes_no"
                            [(ngModel)]="hgValue.value2" (click)="getValue($event)" />
                        <label class="custom-control-label" for="No"></label>
                    </div>
                </label>
            </div>
        </div>
    </div>
    <div class="row col-sm-12 m-auto">
        <div style="width:100% !important;">
            <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
        </div>
        <br />
        <div style="width:97% !important; text-align: right;">
            <div *ngIf="user_bot" class="ash_box text-right mb-3" >
                <h1 class="ansMob text-right">{{yes_no}}</h1>
            </div>
        </div>
        <div>
            <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
                <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
                <p class="text-center tiphead">SUGGESTION</p>
                <p class="text-center tipmes">{{questionObj.tip}}</p>
                <!-- <p class="text-center font-weight-bold">SUGGESTION<br>
                    <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
            </div>
        </div>
    </div>
</div>
<!-- <div class="container mobileview mt-2">
    <div class="row col-sm-12">
        <div class="col-sm-3 col-3">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9">
            <div class="arrow_box">
                <h1 class="questionMob text-left">{{question}}</h1>
            </div>
        </div>
    </div>
    <br />
    <div class="row col-sm-12 m-auto">
        <div class="form-group float-label-control m-auto">
            <label for="">Energy Bill Number</label>
            <input type="text" class="form-control" [(ngModel)]="energy_bill_number" placeholder="Energy Bill Number"
                (keyup.enter)="next();" />
        </div>
        <div *ngIf="user_bot" class="ash_box text-right mt-2">
            <h1 class="ansMob text-right">{{energy_bill_number}}</h1>
        </div>
    </div>
</div> -->
<!-- <div class="btm-process webview">
    <div class="text-center">
      <span><img src="assets/images/active27.png"></span>
      <h4 class="clr333 processtxt">15% Completed</h4>
    </div>
  </div> -->